var _style, _rect, _g, _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle5, _ellipse, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _polygon, _polygon2, _polygon3, _path18, _path19, _path20, _polygon4, _path21, _path22, _path23, _path24, _polygon5, _polygon6, _path25, _polygon7, _path26, _path27, _circle6, _circle7, _circle8, _path28, _path29, _path30, _path31, _path32, _path33, _rect2, _rect3, _circle9, _circle10, _g2, _polygon8, _path34, _polygon9, _path35, _path36, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLantern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#544C61;}\n\t.st1{fill:#EEF2F4;}\n\t.st2{enable-background:new    ;}\n\t.st3{fill:#515362;}\n\t.st4{opacity:0.86;fill:#4C6166;enable-background:new    ;}\n\t.st5{opacity:0.61;fill:url(#XMLID_4_);enable-background:new    ;}\n\t.st6{opacity:0.89;fill:url(#XMLID_5_);enable-background:new    ;}\n\t.st7{fill:none;stroke:#323345;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:#1C6F45;}\n\t.st9{opacity:0.59;fill:#C8A82F;enable-background:new    ;}\n\t.st10{fill:#145B34;}\n\t.st11{fill:#DFC19F;}\n\t.st12{fill:url(#XMLID_6_);}\n\t.st13{fill:#ECDBC9;}\n\t.st14{fill:none;stroke:#323345;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st15{fill:#1B6E44;}\n\t.st16{opacity:0.3;fill:url(#XMLID_14_);enable-background:new    ;}\n\t.st17{opacity:0.3;fill:url(#XMLID_23_);enable-background:new    ;}\n\t.st18{opacity:0.3;fill:url(#XMLID_26_);enable-background:new    ;}\n\t.st19{fill:#323345;}\n\t.st20{fill:#FBAF41;}\n\t.st21{fill:#CC8127;}\n\t.st22{fill:#C8A82F;}\n\t.st23{fill:none;stroke:#323345;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_22_",
    className: "st0",
    width: 1000,
    height: 1000
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.2,959.2c0,2.5-1.2,3.7-2.6,3.7c-1.1,0-1.9-0.5-2.1-1.4c-0.4,0.5-1,0.8-1.8,0.8c-1.5,0-2.6-1.2-2.6-2.8 s1.1-2.8,2.6-2.8c0.7,0,1.2,0.3,1.6,0.7v-0.5h1.6v3.9c0,0.8,0.3,1.4,1,1.4c0.9,0,1.7-0.9,1.7-3c0-3-2.3-5.3-5.4-5.3 c-3.1,0-5.6,2.4-5.6,5.7s2.5,5.7,5.9,5.7c1.1,0,2.1-0.2,2.9-0.4v0.6c-0.8,0.3-1.7,0.4-2.9,0.4c-3.7,0-6.5-2.6-6.5-6.2 c0-3.4,2.7-6.2,6.2-6.2C61.1,953.3,63.2,956.4,63.2,959.2z M58.3,959.5c0-0.8-0.6-1.4-1.3-1.4c-0.8,0-1.3,0.5-1.3,1.4 c0,0.8,0.6,1.3,1.3,1.3C57.8,960.9,58.3,960.3,58.3,959.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.4,955.1v2c-1.2-0.1-2.6,0.5-2.6,2.4v4.3h-1.9v-8.6h1.9v1.4C67.3,955.5,68.3,955.1,69.4,955.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.6,962.3c1,0,1.8-0.5,2.2-1.1l1.5,0.9c-0.8,1.2-2.1,1.9-3.8,1.9c-2.8,0-4.7-1.9-4.7-4.5 c0-2.5,1.8-4.5,4.5-4.5c2.6,0,4.3,2.1,4.3,4.5c0,0.3,0,0.5-0.1,0.8h-6.8C72.1,961.6,73.2,962.3,74.6,962.3z M76.9,958.8 c-0.3-1.5-1.3-2.1-2.5-2.1c-1.4,0-2.3,0.8-2.6,2.1H76.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.9,955.2v8.6H87v-1.2c-0.7,0.9-1.7,1.5-3,1.5c-2.3,0-4.3-2-4.3-4.5c0-2.6,1.9-4.5,4.3-4.5 c1.3,0,2.3,0.5,3,1.4v-1.2L88.9,955.2L88.9,955.2z M87.1,959.5c0-1.6-1.2-2.7-2.7-2.7s-2.7,1.1-2.7,2.7c0,1.6,1.2,2.7,2.7,2.7 C85.9,962.3,87.1,961.1,87.1,959.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.1,951.3H93v12.5h-1.9V951.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.9,955.2l-3.3,8.6h-2.1l-3.3-8.6h2l2.4,6.5l2.4-6.5H102.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.2,955.2h1.9v8.9c0,2.4-1.2,3.5-3.5,3.3v-1.8c1.1,0.1,1.7-0.3,1.7-1.5L104.2,955.2L104.2,955.2z  M104,952.8c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2c0,0.6-0.5,1.2-1.2,1.2S104,953.4,104,952.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116,955.2l-3.3,8.8c-0.8,2.2-2.2,3.3-4.2,3.2v-1.7c1.2,0.1,1.9-0.5,2.3-1.7l0.1-0.2l-3.6-8.4h2l2.6,6.2 l2.2-6.2L116,955.2L116,955.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.9,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C210.4,934.9,211.9,936.6,211.9,938.7z M210.9,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C209.8,941.6,210.9,940.3,210.9,938.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.2,940.8h-3.4l-0.6,1.7h-1.1l2.8-7.6h1.1l2.8,7.6h-1.1L219.2,940.8z M218.9,939.9l-1.4-3.8l-1.4,3.8 H218.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.8,939.4v3.1h-1v-3.1l-2.7-4.5h1.1l2.1,3.6l2.1-3.6h1.1L225.8,939.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.7,941.7l2.7-2.7c0.6-0.6,1.1-1.2,1.1-1.9c0-0.9-0.6-1.4-1.4-1.4c-0.7,0-1.2,0.3-1.6,1l-0.9-0.5 c0.5-1,1.4-1.5,2.4-1.5c1.2,0,2.4,0.8,2.4,2.3c0,0.9-0.6,1.8-1.4,2.5l-2,1.9h3.5v1h-4.9V941.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246,934.9v7.6h-1V936l-1.6,0.5l-0.3-0.9l2-0.7H246z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.9,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C57.4,934.9,58.9,936.6,58.9,938.7z M57.9,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C56.8,941.6,57.9,940.3,57.9,938.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,941.6v1h-4.6v-7.6h4.5v1h-3.5v2.3h3.2v0.9h-3.2v2.4H66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.5,940.8l0.9-0.5c0.3,0.8,0.9,1.4,2,1.4c1.1,0,1.6-0.5,1.6-1.2c0-0.8-0.7-1-1.8-1.4 c-1.2-0.4-2.4-0.8-2.4-2.2c0-1.4,1.1-2.2,2.4-2.2c1.3,0,2.2,0.7,2.6,1.7l-0.8,0.5c-0.3-0.7-0.8-1.2-1.7-1.2 c-0.8,0-1.4,0.4-1.4,1.1c0,0.7,0.5,1,1.6,1.3c1.3,0.4,2.6,0.8,2.6,2.3c0,1.3-1.1,2.2-2.6,2.2C70.9,942.7,69.9,941.9,69.5,940.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.1,934.9v7.6h-1v-7.6H79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.1,939.2c0,1.9-1.4,3.5-3.7,3.5c-2.4,0-4-1.8-4-4c0-2.2,1.7-4,4-4c1.4,0,2.7,0.8,3.3,1.8l-0.9,0.5 c-0.4-0.8-1.4-1.4-2.4-1.4c-1.8,0-3,1.3-3,3c0,1.7,1.2,3,3,3c1.6,0,2.5-0.9,2.7-2h-2.8v-0.9h3.8V939.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,934.9v7.6h-0.8l-3.9-5.7v5.7h-1v-7.6h0.8l3.9,5.7v-5.7H99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.3,941.6v1h-4.6v-7.6h4.5v1h-3.5v2.3h3.2v0.9h-3.2v2.4H107.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.1,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C115.6,934.9,117.1,936.6,117.1,938.7z M116.1,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C115,941.6,116.1,940.3,116.1,938.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.5,940.4c0,1.2-1,2.2-2.2,2.2H125v-7.6h3.1c1.2,0,2.1,0.9,2.1,2.1c0,0.7-0.3,1.2-0.8,1.6 C130.1,938.9,130.5,939.5,130.5,940.4z M126.1,935.8v2.3h2c0.6,0,1.1-0.5,1.1-1.2c0-0.6-0.5-1.2-1.1-1.2H126.1z M129.5,940.3 c0-0.7-0.5-1.2-1.2-1.2h-2.3v2.5h2.3C129,941.6,129.5,941,129.5,940.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.4,939.4v3.1h-1v-3.1l-2.7-4.5h1.1l2.1,3.6l2.1-3.6h1.1L136.4,939.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.5,962.3v1.9h-7.1v-12.4h2v10.4H212.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.6,955.4v8.8h-1.9V963c-0.7,0.9-1.7,1.5-3.1,1.5c-2.4,0-4.4-2-4.4-4.7c0-2.6,2-4.7,4.4-4.7 c1.4,0,2.4,0.6,3.1,1.5v-1.3H222.6z M220.6,959.9c0-1.6-1.2-2.8-2.8-2.8c-1.6,0-2.8,1.2-2.8,2.8c0,1.6,1.2,2.8,2.8,2.8 C219.4,962.7,220.6,961.5,220.6,959.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.8,958.9v5.4h-1.9v-5.2c0-1.3-0.8-2.1-2-2.1c-1.3,0-2.2,0.7-2.2,2.5v4.7h-1.9v-8.8h1.9v1.1 c0.6-0.9,1.5-1.4,2.7-1.4C231.4,955.2,232.8,956.6,232.8,958.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237.6,957.3v4.2c0,1.1,0.7,1.1,2.2,1v1.7c-2.9,0.4-4.1-0.5-4.1-2.8v-4.2h-1.6v-1.8h1.6v-1.9l1.9-0.6v2.5h2.2 v1.8H237.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.6,962.8c1.1,0,1.9-0.5,2.3-1.1l1.6,0.9c-0.8,1.2-2.1,1.9-3.9,1.9c-2.9,0-4.8-2-4.8-4.7 c0-2.6,1.9-4.7,4.7-4.7c2.6,0,4.4,2.1,4.4,4.7c0,0.3,0,0.5-0.1,0.8h-7C243,962.1,244.1,962.8,245.6,962.8z M247.9,959.1 c-0.3-1.5-1.4-2.2-2.5-2.2c-1.4,0-2.4,0.8-2.7,2.2H247.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.2,955.3v2.1c-1.3-0.1-2.7,0.5-2.7,2.5v4.5h-1.9v-8.8h1.9v1.5C254,955.7,255,955.3,256.2,955.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.6,958.9v5.4h-1.9v-5.2c0-1.3-0.8-2.1-2-2.1c-1.3,0-2.2,0.7-2.2,2.5v4.7h-1.9v-8.8h1.9v1.1 c0.6-0.9,1.5-1.4,2.7-1.4C264.2,955.2,265.6,956.6,265.6,958.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M846.1,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C844.6,934.9,846.1,936.6,846.1,938.7z M845.2,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C844.1,941.6,845.2,940.3,845.2,938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M849.3,938.7c0-2.2,1.7-4,3.9-4s4,1.8,4,4s-1.7,4-4,4C851,942.7,849.3,940.9,849.3,938.7z M856.1,938.7 c0-1.7-1.3-3-2.9-3c-1.7,0-2.9,1.3-2.9,3s1.3,3,2.9,3C854.9,941.7,856.1,940.4,856.1,938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M859.8,934.9h1.1l1.7,6.3l1.9-6.3h1l1.9,6.3l1.7-6.3h1.1l-2.2,7.6h-1.2l-1.8-6.1l-1.8,6.1H862L859.8,934.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M879.3,934.9v7.6h-0.8l-3.9-5.7v5.7h-1v-7.6h0.8l3.9,5.7v-5.7H879.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M887.5,941.6v1h-4.3V935h1v6.7h3.3V941.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M889.9,938.7c0-2.2,1.7-4,3.9-4s4,1.8,4,4s-1.7,4-4,4C891.6,942.7,889.9,940.9,889.9,938.7z M896.8,938.7 c0-1.7-1.3-3-2.9-3c-1.7,0-2.9,1.3-2.9,3s1.3,3,2.9,3S896.8,940.4,896.8,938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M905.4,940.8H902l-0.6,1.7h-1.1l2.8-7.6h1.1l2.8,7.6h-1L905.4,940.8z M905.1,939.9l-1.4-3.8l-1.4,3.8H905.1z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M916.9,938.7c0,2.1-1.5,3.8-3.6,3.8h-3v-7.6h3C915.4,934.9,916.9,936.6,916.9,938.7z M915.9,938.7 c0-1.6-1.1-2.9-2.6-2.9h-2v5.7h2C914.9,941.6,915.9,940.3,915.9,938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M926.5,935.8v2.5h3.2v1h-3.2v3.2h-1v-7.6h4.4v1h-3.4V935.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M936.2,939.6h-1.8v2.9h-1v-7.6h3c1.3,0,2.4,1.1,2.4,2.4c0,1-0.7,1.9-1.6,2.2l1.8,3.1h-1.1L936.2,939.6z  M934.4,938.7h2c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4h-2V938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M941.9,938.7c0-2.2,1.7-4,3.9-4s4,1.8,4,4s-1.7,4-4,4C943.6,942.7,941.9,940.9,941.9,938.7z M948.8,938.7 c0-1.7-1.3-3-2.9-3c-1.7,0-2.9,1.3-2.9,3s1.3,3,2.9,3S948.8,940.4,948.8,938.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M960.4,942.5h-1v-6l-2.5,4.2h-0.1l-2.5-4.1v5.9h-1v-7.6h1.1l2.4,4l2.4-4h1.1L960.4,942.5L960.4,942.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M839.3,952.9c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2s-0.5,1.2-1.2,1.2C839.9,954.1,839.3,953.6,839.3,952.9z  M839.6,955.4h1.9v8.9h-1.9V955.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M843.7,951.4h1.9v12.9h-1.9V951.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M847.8,951.4h1.9v12.9h-1.9V951.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M852,951.4h1.9v12.9H852V951.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M864,955.4v8.9h-1.9v-1.1c-0.6,0.9-1.5,1.4-2.7,1.4c-2,0-3.4-1.3-3.4-3.6v-5.4h1.9v5.2c0,1.3,0.8,2.1,2,2.1 c1.3,0,2.2-0.7,2.2-2.5v-4.7h1.9V955.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M872.6,961.8c0,1.8-1.5,2.7-3.5,2.7c-1.8,0-3-0.8-3.6-2.1l1.6-1c0.3,0.8,1,1.3,2,1.3c0.8,0,1.5-0.3,1.5-1 c0-1.6-4.8-0.7-4.8-3.9c0-1.7,1.4-2.7,3.2-2.7c1.5,0,2.7,0.7,3.3,1.8l-1.6,0.9c-0.3-0.7-0.9-1-1.7-1c-0.7,0-1.3,0.3-1.3,0.9 C867.9,959.5,872.6,958.5,872.6,961.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M876.7,957.3v4.2c0,1.1,0.7,1.1,2.2,1v1.7c-2.9,0.4-4.1-0.5-4.1-2.8v-4.2h-1.6v-1.8h1.6v-1.9l1.9-0.6v2.5 h2.2v1.8L876.7,957.3L876.7,957.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M885.4,955.3v2.1c-1.3-0.1-2.7,0.5-2.7,2.5v4.5h-1.9v-8.9h1.9v1.5C883.2,955.7,884.2,955.3,885.4,955.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M895.3,955.4v8.9h-1.9V963c-0.7,0.9-1.7,1.5-3.1,1.5c-2.4,0-4.4-2-4.4-4.7c0-2.6,2-4.7,4.4-4.7 c1.4,0,2.4,0.6,3.1,1.5v-1.3h1.9V955.4z M893.4,959.9c0-1.6-1.2-2.8-2.8-2.8s-2.8,1.2-2.8,2.8s1.2,2.8,2.8,2.8 S893.4,961.5,893.4,959.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M900.3,957.3v4.2c0,1.1,0.7,1.1,2.2,1v1.7c-2.9,0.4-4.1-0.5-4.1-2.8v-4.2h-1.6v-1.8h1.6v-1.9l1.9-0.6v2.5 h2.2v1.8L900.3,957.3L900.3,957.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M903.9,952.9c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2s-0.5,1.2-1.2,1.2C904.5,954.1,903.9,953.6,903.9,952.9z  M904.2,955.4h1.9v8.9h-1.9V955.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M907.8,959.9c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2,4.7,4.7c0,2.6-2.1,4.7-4.7,4.7 C909.9,964.5,907.8,962.5,907.8,959.9z M915.3,959.9c0-1.6-1.2-2.8-2.8-2.8s-2.8,1.2-2.8,2.8s1.2,2.8,2.8,2.8 S915.3,961.5,915.3,959.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M927,958.9v5.4h-1.9v-5.2c0-1.3-0.8-2.1-2-2.1c-1.3,0-2.2,0.7-2.2,2.5v4.7H919v-8.9h1.9v1.1 c0.6-0.9,1.5-1.4,2.7-1.4C925.5,955.2,927,956.6,927,958.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M935.5,961.8c0,1.8-1.5,2.7-3.5,2.7c-1.8,0-3-0.8-3.6-2.1l1.6-1c0.3,0.8,1,1.3,2,1.3c0.8,0,1.5-0.3,1.5-1 c0-1.6-4.8-0.7-4.8-3.9c0-1.7,1.4-2.7,3.2-2.7c1.5,0,2.7,0.7,3.3,1.8l-1.6,0.9c-0.3-0.7-0.9-1-1.7-1c-0.7,0-1.3,0.3-1.3,0.9 C930.7,959.5,935.5,958.5,935.5,961.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M936.8,963.2c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3C937.4,964.5,936.8,963.9,936.8,963.2z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M940.3,959.9c0-2.6,2-4.7,4.7-4.7c1.7,0,3.2,0.9,3.9,2.3l-1.6,1c-0.4-0.8-1.3-1.4-2.3-1.4 c-1.6,0-2.7,1.2-2.7,2.8s1.2,2.8,2.7,2.8c1.1,0,1.9-0.5,2.4-1.4l1.6,0.9c-0.7,1.4-2.2,2.3-4,2.3 C942.3,964.5,940.3,962.5,940.3,959.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M949.7,959.9c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2,4.7,4.7c0,2.6-2.1,4.7-4.7,4.7 C951.8,964.5,949.7,962.5,949.7,959.9z M957.2,959.9c0-1.6-1.2-2.8-2.8-2.8s-2.8,1.2-2.8,2.8s1.2,2.8,2.8,2.8 S957.2,961.5,957.2,959.9z"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_70_",
    className: "st3",
    cx: 500,
    cy: 524.5,
    r: 369.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_69_",
    className: "st4",
    cx: 500,
    cy: 524.5,
    r: 281.8
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_4_",
    cx: 500,
    cy: 475.5,
    r: 534.3067,
    gradientTransform: "matrix(1 0 0 -1 0 1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F29543"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1095,
    style: {
      stopColor: "#F09543",
      stopOpacity: 0.8014
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1711,
    style: {
      stopColor: "#E79645",
      stopOpacity: 0.6898
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2208,
    style: {
      stopColor: "#DA9747",
      stopOpacity: 0.5997
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2641,
    style: {
      stopColor: "#C6994A",
      stopOpacity: 0.5211
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3033,
    style: {
      stopColor: "#AC9B4E",
      stopOpacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3396,
    style: {
      stopColor: "#8D9E53",
      stopOpacity: 0.3844
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3735,
    style: {
      stopColor: "#68A259",
      stopOpacity: 0.3228
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4057,
    style: {
      stopColor: "#3CA661",
      stopOpacity: 0.2645
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4353,
    style: {
      stopColor: "#0DAA68",
      stopOpacity: 0.2108
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4413,
    style: {
      stopColor: "#02AB6A",
      stopOpacity: 0.2
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_34_",
    className: "st5",
    cx: 500,
    cy: 524.5,
    r: 211
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_5_",
    cx: 500,
    cy: 475.5,
    r: 149.3,
    gradientTransform: "matrix(1 0 0 -1 0 1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F29543"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1302,
    style: {
      stopColor: "#EB9847",
      stopOpacity: 0.8637
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3179,
    style: {
      stopColor: "#D8A151",
      stopOpacity: 0.667
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5405,
    style: {
      stopColor: "#B9AF61",
      stopOpacity: 0.4339
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7638,
    style: {
      stopColor: "#92C176",
      stopOpacity: 0.2
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_54_",
    className: "st6",
    cx: 500,
    cy: 524.5,
    r: 149.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_60_",
    className: "st7",
    d: "M617.9,568.5l-32.2-202.3c-3-18.5-24.2-32.7-47.6-32.7H464c-23.4,0-44.6,14.1-47.6,32.7 l-32.2,202.3c-6.1,38.6,19,73,56.9,73H561C598.8,641.5,624,607.1,617.9,568.5z M587.2,608.9c-4.6,5.4-12.9,12.6-26.2,12.6H441 c-13.3,0-21.6-7.5-26.2-12.9c-7.8-9.2-11.1-22.7-8.9-36.1l32.2-201.6c0.9-5.8,11.4-13.4,25.8-13.4H538c14.4,0,24.9,7.4,25.8,13.2 L596,572.5C598.3,586,595,599.7,587.2,608.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st8",
    d: "M617.9,568.5l-32.2-202.3c-3-18.5-24.2-32.7-47.6-32.7H464c-23.4,0-44.6,14.1-47.6,32.7 l-32.2,202.3c-6.1,38.6,19,73,56.9,73H561C598.8,641.5,624,607.1,617.9,568.5z M587.2,608.9c-4.6,5.4-12.9,12.6-26.2,12.6H441 c-13.3,0-21.6-7.5-26.2-12.9c-7.8-9.2-11.1-22.7-8.9-36.1l32.2-201.6c0.9-5.8,11.4-13.4,25.8-13.4H538c14.4,0,24.9,7.4,25.8,13.2 L596,572.5C598.3,586,595,599.7,587.2,608.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_82_",
    className: "st8",
    d: "M617.9,568.5l-32.2-202.3c-3-18.5-24.2-32.7-47.6-32.7H464c-23.4,0-44.6,14.1-47.6,32.7 l-32.2,202.3c-6.1,38.6,19,73,56.9,73H561C598.8,641.5,624,607.1,617.9,568.5z M587.2,608.9c-4.6,5.4-12.9,12.6-26.2,12.6H441 c-13.3,0-21.6-7.5-26.2-12.9c-7.8-9.2-11.1-22.7-8.9-36.1l32.2-201.6c0.9-5.8,11.4-13.4,25.8-13.4H538c14.4,0,24.9,7.4,25.8,13.2 L596,572.5C598.3,586,595,599.7,587.2,608.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_194_",
    className: "st9",
    d: "M405.9,572.5l23.9-149.3c-6.3-4.9-13.1-9.1-20.5-12.3l-25.1,157.7c-1.5,9.5-1.1,18.8,0.9,27.4 c7.4-1,14.4-2.9,21.1-5.5C405,584.7,404.9,578.6,405.9,572.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_193_",
    className: "st9",
    d: "M596.1,572.5c0.8,5.2,0.8,10.5,0.1,15.5c6.6,3.1,13.6,5.5,20.9,7c1.8-8.3,2.2-17.2,0.7-26.4 l-24.7-155c-7.3,3.8-14.1,8.6-20.2,14.1L596.1,572.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st7",
    d: "M561,641.5H441c-37.8,0-63-34.4-56.9-73l32.2-202.3c3-18.5,24.2-32.7,47.6-32.7H538 c23.4,0,44.6,14.1,47.6,32.7l32.2,202.3C624,607.1,598.8,641.5,561,641.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "st10",
    d: "M617.9,568.5l-32.2-202.3c-3-18.5-24.2-32.7-47.6-32.7H464c-23.4,0-44.6,14.1-47.6,32.7 l-32.2,202.3c-6.1,38.6,19,73,56.9,73H561C598.8,641.5,624,607.1,617.9,568.5z M596.3,615.4c-8.9,10.4-21.4,16.1-35.4,16.1H441 c-14,0-26.5-5.7-35.4-16.1c-10.1-11.8-14.3-28.4-11.6-45.3l32.2-202.3c2.1-13.4,19-24.3,37.7-24.3H538c18.6,0,35.5,10.9,37.7,24.3 L608,570.1C610.7,587.1,606.4,603.6,596.3,615.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    className: "st7",
    d: "M617.9,568.5l-32.2-202.3c-3-18.5-24.2-32.7-47.6-32.7H464c-23.4,0-44.6,14.1-47.6,32.7 l-32.2,202.3c-6.1,38.6,19,73,56.9,73H561C598.8,641.5,624,607.1,617.9,568.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    className: "st11",
    d: "M529.7,423.2c-20.2,0-40.4,0-60.5,0c-15.9,18.3-29.9,42.5-36.1,71.4 c-7.3,32.8-2.4,69.5,12.9,97.8c5.7,10.6,17.8,17.5,29.8,17.5c16.3,0,32.7,0,49,0c12.2,0,24.6-7.1,30.1-17.9 c14-27.5,19.1-63.8,9.6-101.9C557.6,461.3,544.3,438.6,529.7,423.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_6_",
    cx: 500.4,
    cy: 475.5,
    r: 57,
    gradientTransform: "matrix(1 0 0 -1 0 1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1237,
    style: {
      stopColor: "#F2CA91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2CA91",
      stopOpacity: 0.3
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_72_",
    className: "st12",
    cx: 500.4,
    cy: 524.5,
    r: 57
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_45_",
    transform: "matrix(0.2737 -0.9618 0.9618 0.2737 -96.1773 787.5897)",
    className: "st13",
    cx: 473.4,
    cy: 457.5,
    rx: 30.5,
    ry: 13.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st14",
    d: "M529.7,424.2c-20.2,0-40.4,0-60.5,0c-15.9,18.3-29.9,42.1-36.1,70.9 c-7.3,32.8-2.4,69.8,12.9,98.1c5.7,10.6,17.8,17.7,29.8,17.7c16.3,0,32.7,0,49,0c12.2,0,24.6-7.6,30.1-18.4 c14-27.5,19.1-63.6,9.6-101.6C557.6,462,544.3,439.6,529.7,424.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st10",
    d: "M561,656.5H439V637c0-6.6,5.4-12,12-12h98c6.6,0,12,5.4,12,12V656.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st15",
    d: "M543.3,649.7h-86.7v-6.2c0-6.6,5.4-12,12-12h62.7c6.6,0,12,5.4,12,12V649.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_138_",
    className: "st9",
    d: "M549,625h-98c-6.6,0-12,4.2-12,9.3v6.5c0-5.1,5.4-9.3,12-9.3h98c6.6,0,12,4.2,12,9.3v-6.5 C561,629.2,555.6,625,549,625z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st7",
    d: "M561,656.5H439V637c0-6.6,5.4-12,12-12h98c6.6,0,12,5.4,12,12V656.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st15",
    d: "M590.8,684.5h-182v-4c0-13.3,10.8-24,24-24h133.9c13.3,0,24,10.8,24,24v4H590.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_90_",
    className: "st10",
    d: "M409.4,675c-0.4,1.8-0.6,3.6-0.6,5.5v4h182v-4c0-1.9-0.2-3.8-0.6-5.5H409.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_99_",
    className: "st9",
    d: "M566.8,656.5h-134c-13.3,0-24,10.8-24,24v4h0.2c1.3-12,11.5-21.3,23.9-21.3h133.9 c12.4,0,22.5,9.3,23.9,21.3h0.2v-4C590.8,667.3,580,656.5,566.8,656.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 499.8,
    y1: 315.5,
    x2: 499.8,
    y2: 9.094947e-13,
    gradientTransform: "matrix(1 0 0 -1 0 1000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292E42",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#151721",
      stopOpacity: 0
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_83_",
    className: "st16",
    points: "753,1000 246.6,1000 408.8,684.5 590.8,684.5 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 499.8,
    y1: 315.5,
    x2: 499.8,
    y2: 9.094947e-13,
    gradientTransform: "matrix(1 0 0 -1 0 1000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292E42",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#151721",
      stopOpacity: 0
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_84_",
    className: "st17",
    points: "695,1000 304.6,1000 408.8,684.5 590.8,684.5 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 499.8,
    y1: 315.5,
    x2: 499.8,
    y2: 9.094947e-13,
    gradientTransform: "matrix(1 0 0 -1 0 1000)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#292E42",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#151721",
      stopOpacity: 0
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_95_",
    className: "st18",
    points: "627.6,1000 372,1000 408.8,684.5 590.8,684.5 "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st7",
    d: "M590.8,684.5h-182v-4c0-13.3,10.8-24,24-24h133.9c13.3,0,24,10.8,24,24v4H590.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_63_",
    className: "st10",
    d: "M544.3,433.3c-30,0-60,0-90,0c0.9-6.5,5.1-13.5,10.7-20c22.9,0,45.8,0,68.7,0 C539.3,419.8,543.4,426.8,544.3,433.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_68_",
    className: "st15",
    d: "M509.3,433.3h-20c-7.8,0-13.1-7.8-10.4-15.1c0.6-1.6,1.3-3.3,2-4.9c17.3,0,19.3,0,36.6,0 c0.7,1.6,1.4,3.2,2,4.9C522.5,425.4,517.1,433.3,509.3,433.3z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_40_",
    className: "st10",
    points: "549.5,379.5 448.5,379.5 457.6,370.8 540.4,370.8 "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st7",
    d: "M544.3,433.3c-30,0-60,0-90,0c0.9-6.5,5.1-13.5,10.7-20c22.9,0,45.8,0,68.7,0 C539.3,419.8,543.4,426.8,544.3,433.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st10",
    d: "M529.7,380.5h-60.8l-3.2,8c-0.5,1.2-0.7,2.4-0.7,3.6v21.4h69v-21.2c0-1.4-0.3-2.7-0.8-3.9 L529.7,380.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_77_",
    className: "st15",
    d: "M505.7,380.5h-12.5c-4.7,0-8.8,3.4-9.7,8l0,0c-0.2,1.2-0.3,2.4-0.3,3.6v8.7 c0,7,5.7,12.6,12.6,12.6h7.2c7,0,12.6-5.7,12.6-12.6v-8.6c0-1.4-0.1-2.7-0.4-3.9l0,0C514.4,383.8,510.4,380.5,505.7,380.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st7",
    d: "M529.7,380.5h-60.8l-3.2,8c-0.5,1.2-0.7,2.4-0.7,3.6v21.4h69v-21.2c0-1.4-0.3-2.7-0.8-3.9 L529.7,380.5z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_11_",
    className: "st7",
    points: "549.5,379.5 448.5,379.5 457.6,370.8 540.4,370.8 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_33_",
    className: "st10",
    points: "533.9,318.2 463.2,318.2 457.6,370.8 539.5,370.8 "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_74_",
    className: "st15",
    d: "M519.9,318.2h-42.7l-2.1,33c-0.7,10.6,7.7,19.6,18.3,19.6h10.3c10.6,0,19-9,18.3-19.6 L519.9,318.2z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_12_",
    className: "st7",
    points: "533.9,318.2 463.2,318.2 457.6,370.8 539.5,370.8 "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    className: "st10",
    d: "M530.8,310.5c-5.9,0-11.6-2.5-15.6-6.9s-9.8-7.1-16.2-7.1c-6.4,0-12.2,2.7-16.2,7.1 s-9.7,6.9-15.6,6.9H453v8h92v-8H530.8z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st7",
    d: "M530.8,310.5c-5.9,0-11.6-2.5-15.6-6.9s-9.8-7.1-16.2-7.1c-6.4,0-12.2,2.7-16.2,7.1 s-9.7,6.9-15.6,6.9H453v8h92v-8H530.8z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_13_",
    className: "st19",
    cx: 482.7,
    cy: 396.3,
    r: 4.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_19_",
    className: "st19",
    cx: 499.2,
    cy: 396.3,
    r: 4.8
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_49_",
    className: "st19",
    cx: 515.7,
    cy: 396.3,
    r: 4.8
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    className: "st20",
    d: "M503.5,512c-1.6,4.4-4.4,10.8-9.5,17.5c-8.6,11.3-14.6,11.6-18,19.5 c-3.9,9.1-2.1,23.5,7.9,31.8c10.3,8.5,24.3,6.5,33.1,1.7c16.2-9,16.5-29,16.5-31C533.5,534.9,521.6,519.2,503.5,512z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st21",
    d: "M506.5,524c-2.1,3.9-5.5,9.5-11,15c-8.5,8.5-13.6,8.3-17,14.5c-4.2,7.6-3.4,20.3,4.6,27.8 c9.1,8.4,22.5,5.8,30.2,1.5c15.3-8.5,15.1-27.5,15.1-28.3C528,541.5,519.4,529.6,506.5,524z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "st14",
    d: "M503.5,512c-1.6,4.4-4.4,10.8-9.5,17.5c-8.6,11.3-14.6,11.6-18,19.5 c-3.9,9.1-2.1,23.5,7.9,31.8c10.3,8.5,24.3,6.5,33.1,1.7c16.2-9,16.5-29,16.5-31C533.5,534.9,521.6,519.2,503.5,512z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "st15",
    d: "M525.8,609.5c-3.9-21-14.2-35.6-26.2-35.6c-12.1,0-22.3,14.6-26.2,35.6H525.8z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_97_",
    className: "st22",
    d: "M499.6,582.5c10,0,18.9,7.5,24.5,19.4c-4.8-16.8-13.9-27.9-24.5-27.9 c-10.5,0-19.7,11.1-24.5,27.9C480.7,590,489.6,582.5,499.6,582.5z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st14",
    d: "M525.8,609.5c-3.9-21-14.2-35.6-26.2-35.6c-12.1,0-22.3,14.6-26.2,35.6H525.8z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_28_",
    x: 468,
    y: 600.7,
    className: "st10",
    width: 64,
    height: 9.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_16_",
    x: 468,
    y: 600.7,
    className: "st14",
    width: 64,
    height: 9.2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_52_",
    className: "st19",
    cx: 584.5,
    cy: 353.5,
    r: 10
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_55_",
    className: "st19",
    cx: 417.5,
    cy: 353.5,
    r: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_59_",
    className: "st23",
    d: "M577.3,367.8l2.4-15.9c0.1,0,0.2,0,0.4,0c9.5,0,17.2-7.6,17.2-17c0-7.8-5.3-14.3-12.4-16.3 l14.9-98c4.7-30.7-19.3-58.4-50.7-58.4H499h-50.1c-31.4,0-55.4,27.6-50.7,58.4l14.9,98c-6.9,1.4-12.4,8.6-12.4,16.3 c0,9.4,7.7,17,17.2,17c0.1,0,0.2,0,0.4,0l2.4,15.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st19",
    d: "M512.7,170h-28.3c-2.8,0-5.1-2.3-5.1-5.1v-7.2c0-2.8,2.3-5.1,5.1-5.1h28.3 c2.8,0,5.1,2.3,5.1,5.1v7.2C517.8,167.7,515.5,170,512.7,170z"
  }))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_67_",
    className: "st15",
    points: "545.8,625 454.2,625 468.1,608 532,608 "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_112_",
    className: "st9",
    d: "M464.6,612.3c8.4,4.7,21.2,7.7,35.5,7.7c14.3,0,27.1-3,35.5-7.7L532,608h-63.9L464.6,612.3z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_61_",
    className: "st14",
    points: "545.8,625 454.2,625 468.1,608 532,608 "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_86_",
    className: "st14",
    d: "M596.3,615.4c-8.9,10.4-21.4,16.1-35.4,16.1H441c-14,0-26.5-5.7-35.4-16.1 c-10.1-11.8-14.3-28.4-11.6-45.3l32.2-202.3c2.1-13.4,19-24.3,37.7-24.3H538c18.6,0,35.5,10.9,37.7,24.3L608,570.1 C610.7,587.1,606.4,603.6,596.3,615.4z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_81_",
    className: "st19",
    d: "M512.1,317.5h-28.5c-0.5,0-1-0.4-1-1l0,0c0-5,4-9,9-9h12.5c5,0,9,4,9,9l0,0 C513.1,317.1,512.7,317.5,512.1,317.5z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st20",
    d: "M503.4,541.5c0.3,1.9,0.5,4.4,0.2,7.2c-0.2,3.1-0.9,5.8-1.6,7.8c-1-4.3-3.8-8.1-4.2-7.9 c0,0,0,0,0,0.1c-0.2,0.9-4.9,6.8-5.8,8.1c-2.4,3.6-2.9,11.3,1.3,15.3c3.6,3.4,9.6,3.2,13.6,1.2c6.7-3.4,8-12.3,6.9-18.2 C512.1,546.5,504.7,542.2,503.4,541.5z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st14",
    d: "M503.4,541.5c0.3,1.9,0.5,4.4,0.2,7.2c-0.2,3.1-0.9,5.8-1.6,7.8c-1-4.3-3.8-8.1-4.2-7.9 c0,0,0,0,0,0.1c-0.2,0.9-4.9,6.8-5.8,8.1c-2.4,3.6-2.9,11.3,1.3,15.3c3.6,3.4,9.6,3.2,13.6,1.2c6.7-3.4,8-12.3,6.9-18.2 C512.1,546.5,504.7,542.2,503.4,541.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLantern);
export default __webpack_public_path__ + "static/media/lantern.c7e5d0fdb793dfd8f53635677986f2b1.svg";
export { ForwardRef as ReactComponent };